import Image from 'next/image';
import rk_pefc from '../../images/RK_PEFC_Logo_new.png';
import iti_fcs from '../../images/ITI_FSC_Logo.png';
import archipro from '../../images/Archipro-Footer-Logo-100px.png';
import archipro2x from '../../images/2x/Archipro-Footer-Logo-200x24px.png';
import codemark from '../../images/CodeMark-Footer-Logo-100px.png';
import codemark2x from '../../images/2x/CodeMark-Footer-Logo-200x46px.png';
import Logo from '../../images/RK-Logo.png';
import Logo2x from '../../images/2x/RK-Footer-Logo-240x156px.png';
import ITILogo2x from '../../images/2x/ITI-Footer-Logo-354x120px.png';
import { urlForImage } from '~/lib/sanity.image';

import Link from 'next/link';

/* eslint-disable @next/next/no-img-element */
const currentYear = new Date().getFullYear();

export default function Footer({ siteConfig }) {
  if (
    typeof window !== 'undefined' &&
    process.env.NEXT_PUBLIC_DEBUG_RENDER === 'true'
  ) {
    // eslint-disable-next-line no-console
    console.log('[render] Footer')
  }

  function createNavigations(navObject) {
    const navigation = []
    if(navObject){
      navObject.items.map((navItem) => {
        let target = '_self'
        let href = ''
        if(navItem.navigationItemUrl.externalUrl){
          href = navItem.navigationItemUrl.externalUrl
          target = "_blank"
        }else {
          href = '/' + navItem.navigationItemUrl.internalLink.slug.current
        }
  
        let navI = {
          name: navItem.text,
          href: href,
          target: target,
          key: navItem._key
        }
        navigation.push(navI)
      })
    }

    return (
      <ul className="text-primary font-thin">
        {navigation.map((item) => (
          <li className="mb-4" key={item.name}>
            <Link href={item.href} target={item.target} className="hover:underline">{item.name}</Link>
          </li>
        ))}      
      </ul>
    );
  }

  const navList = createNavigations(siteConfig.footerNav)
  const logoSrc = siteConfig.logoFooter ? urlForImage(siteConfig.logoFooter).url() : Logo;
  const ITILogoSrc = urlForImage(siteConfig.logoFooter2).url()

  return (
    <footer className="w-full bg-sand">
        <div className="mx-auto w-full max-w-screen-xl p-4 py-6 lg:py-8">
            <div className="md:flex gap-8 md:justify-between">
              <div className="mb-6 md:mb-0">
                <div className='flex flex-col justify-between h-full'>
                  <div className="flex items-center">
                    <a href="https://rktimbers.co.nz/">
                        <img 
                        src={logoSrc} 
                        srcSet={`${logoSrc} 1x, ${Logo2x.src} 2x`}
                        className="me-10" alt="RK Timber" />
                    </a>
                    {siteConfig.logoFooter2 && (
                      <img 
                      src={ITILogoSrc}
                      srcSet={`${ITILogoSrc} 1x, ${ITILogo2x.src} 2x`}
                      alt="secondary logo" />
                      )}
                  </div>
                  <div className="flex mt-6">
                    <div className='flex'>
                      <a href="https://fsc.org/en">
                          <Image src={iti_fcs} className="me-3 max-w-[80px]" alt="FFAF" />
                      </a>
                      <a href="https://www.pefc.org/">
                          <Image src={rk_pefc} className="me-3 max-w-[80px]" alt="PEFC" />
                      </a>   
                    </div>
                  </div>
                  <div className='flex mt-6 md:mt-4'>                 
                    <a href="https://archipro.co.nz/professional/rosenfeld-kidson-and-co" className='flex items-end mb-[4px]'>
                        <img 
                          src={archipro.src} 
                          srcSet={`${archipro.src} 1x, ${archipro2x.src} 2x`}
                          className="me-3" 
                          alt="Archipro" 
                        />
                    </a>
                    <a href="https://www.codemark.co.nz/">
                        <img 
                          src={codemark.src} 
                          srcSet={`${codemark.src} 1x, ${codemark2x.src} 2x`}
                          className="me-3" 
                          alt="CodeMark" 
                        />
                    </a>
                  </div>
                </div>
              </div>
              <div className="grid grid-cols-2 gap-4 sm:gap-6">
                  <div>
                      <h2 className="mb-6 font-bold text-primary uppercase">Home</h2>
                      { navList }
                  </div>
                  <div>
                      <h2 className="mb-6 font-bold text-primary uppercase">Contact Us</h2>
                      <ul className="text-primary font-thin">
                          <li className="mb-4">
                              <a href={ "tel:" + siteConfig.contactAuckland.replace(/\s/g, '') } className="hover:underline">Auckland Head office: { siteConfig.contactAuckland }</a>
                          </li>
                      </ul>
                  </div>
              </div>
          </div>
          <hr className="my-6 border-black sm:mx-auto lg:my-8" />
          <div className="sm:flex sm:items-center sm:justify-between">
              <span className="text-primary sm:text-center font-extralight">
                &copy; {currentYear}&nbsp;
                {siteConfig.copyrightText}
              </span>
              <div className="flex gap-4 text-blue-gray-900 sm:justify-center">
            <a target='_blank' href="http://www.facebook.com/RKTimbersNZ" className="opacity-100 transition-opacity hover:opacity-50 text-black">
              <svg className="h-5 w-5" fill="currentColor" viewBox="0 0 24 24" aria-hidden="true">
                <path
                  fillRule="evenodd"
                  d="M22 12c0-5.523-4.477-10-10-10S2 6.477 2 12c0 4.991 3.657 9.128 8.438 9.878v-6.987h-2.54V12h2.54V9.797c0-2.506 1.492-3.89 3.777-3.89 1.094 0 2.238.195 2.238.195v2.46h-1.26c-1.243 0-1.63.771-1.63 1.562V12h2.773l-.443 2.89h-2.33v6.988C18.343 21.128 22 16.991 22 12z"
                  clipRule="evenodd"
                />
              </svg>
            </a>
            <a target='_blank' href="https://www.instagram.com/rosenfeldkidson/" className="opacity-100 transition-opacity hover:opacity-50 text-black">
              <svg className="h-5 w-5" fill="currentColor" viewBox="0 0 24 24" aria-hidden="true">
                <path
                  fillRule="evenodd"
                  d="M12.315 2c2.43 0 2.784.013 3.808.06 1.064.049 1.791.218 2.427.465a4.902 4.902 0 011.772 1.153 4.902 4.902 0 011.153 1.772c.247.636.416 1.363.465 2.427.048 1.067.06 1.407.06 4.123v.08c0 2.643-.012 2.987-.06 4.043-.049 1.064-.218 1.791-.465 2.427a4.902 4.902 0 01-1.153 1.772 4.902 4.902 0 01-1.772 1.153c-.636.247-1.363.416-2.427.465-1.067.048-1.407.06-4.123.06h-.08c-2.643 0-2.987-.012-4.043-.06-1.064-.049-1.791-.218-2.427-.465a4.902 4.902 0 01-1.772-1.153 4.902 4.902 0 01-1.153-1.772c-.247-.636-.416-1.363-.465-2.427-.047-1.024-.06-1.379-.06-3.808v-.63c0-2.43.013-2.784.06-3.808.049-1.064.218-1.791.465-2.427a4.902 4.902 0 011.153-1.772A4.902 4.902 0 015.45 2.525c.636-.247 1.363-.416 2.427-.465C8.901 2.013 9.256 2 11.685 2h.63zm-.081 1.802h-.468c-2.456 0-2.784.011-3.807.058-.975.045-1.504.207-1.857.344-.467.182-.8.398-1.15.748-.35.35-.566.683-.748 1.15-.137.353-.3.882-.344 1.857-.047 1.023-.058 1.351-.058 3.807v.468c0 2.456.011 2.784.058 3.807.045.975.207 1.504.344 1.857.182.466.399.8.748 1.15.35.35.683.566 1.15.748.353.137.882.3 1.857.344 1.054.048 1.37.058 4.041.058h.08c2.597 0 2.917-.01 3.96-.058.976-.045 1.505-.207 1.858-.344.466-.182.8-.398 1.15-.748.35-.35.566-.683.748-1.15.137-.353.3-.882.344-1.857.048-1.055.058-1.37.058-4.041v-.08c0-2.597-.01-2.917-.058-3.96-.045-.976-.207-1.505-.344-1.858a3.097 3.097 0 00-.748-1.15 3.098 3.098 0 00-1.15-.748c-.353-.137-.882-.3-1.857-.344-1.023-.047-1.351-.058-3.807-.058zM12 6.865a5.135 5.135 0 110 10.27 5.135 5.135 0 010-10.27zm0 1.802a3.333 3.333 0 100 6.666 3.333 3.333 0 000-6.666zm5.338-3.205a1.2 1.2 0 110 2.4 1.2 1.2 0 010-2.4z"
                  clipRule="evenodd"
                />
              </svg>
            </a>
            <a target='_blank' href="https://www.youtube.com/@RKTimbers" className="opacity-100 transition-opacity hover:opacity-50 text-black">
              <svg className="h-5 w-5" fill="currentColor" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" width="24" height="24"  viewBox="0 0 24 24">
                <path fill-rule="evenodd" d="M21.7 8.037a4.26 4.26 0 0 0-.789-1.964 2.84 2.84 0 0 0-1.984-.839c-2.767-.2-6.926-.2-6.926-.2s-4.157 0-6.928.2a2.836 2.836 0 0 0-1.983.839 4.225 4.225 0 0 0-.79 1.965 30.146 30.146 0 0 0-.2 3.206v1.5a30.12 30.12 0 0 0 .2 3.206c.094.712.364 1.39.784 1.972.604.536 1.38.837 2.187.848 1.583.151 6.731.2 6.731.2s4.161 0 6.928-.2a2.844 2.844 0 0 0 1.985-.84 4.27 4.27 0 0 0 .787-1.965 30.12 30.12 0 0 0 .2-3.206v-1.516a30.672 30.672 0 0 0-.202-3.206Zm-11.692 6.554v-5.62l5.4 2.819-5.4 2.801Z" clip-rule="evenodd"/>
              </svg>
            </a>            
            <a target='_blank' href="https://www.linkedin.com/company/rosenfeld-kidson-&-co/" className="opacity-100 transition-opacity hover:opacity-50 text-black">
              <svg className="h-5 w-5" fill="currentColor" viewBox="0 0 24 24" aria-hidden="true">              
                <path fill-rule="evenodd" d="M12.51 8.796v1.697a3.738 3.738 0 0 1 3.288-1.684c3.455 0 4.202 2.16 4.202 4.97V19.5h-3.2v-5.072c0-1.21-.244-2.766-2.128-2.766-1.827 0-2.139 1.317-2.139 2.676V19.5h-3.19V8.796h3.168ZM7.2 6.106a1.61 1.61 0 0 1-.988 1.483 1.595 1.595 0 0 1-1.743-.348A1.607 1.607 0 0 1 5.6 4.5a1.601 1.601 0 0 1 1.6 1.606Z" clip-rule="evenodd"/>
                <path d="M7.2 8.809H4V19.5h3.2V8.809Z"/>
              </svg>
            </a>
            <a target='_blank' href="https://nz.pinterest.com/rktimbersnz/" className="opacity-100 transition-opacity hover:opacity-50 text-black">
              <svg className="h-5 w-5" fill="currentColor" viewBox="0 0 24 24" aria-hidden="true">
                <path fill-rule="evenodd" d="M7.5 4.586A2 2 0 0 1 8.914 4h6.172a2 2 0 0 1 1.414.586L17.914 6H19a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h1.086L7.5 4.586ZM10 12a2 2 0 1 1 4 0 2 2 0 0 1-4 0Zm2-4a4 4 0 1 0 0 8 4 4 0 0 0 0-8Z" clip-rule="evenodd"/>
              </svg>            
            </a>
          </div>
          </div>
        </div>
    </footer>
  );
}
